import React from 'react';
import {Text, VStack} from '@tempo/core';
import type {TdProps} from '@components/Table/core/Td';
import Td from '@components/Table/core/Td';
import type {LabelClaim} from '@deezer/next/services/api/Starmania/requests/claim/types';

type LabelClaimCellProps = {
	claim: LabelClaim;
} & TdProps;

const LabelClaimCell = ({claim, ...rest}: LabelClaimCellProps) => {
	return (
		<Td whiteSpace="pre-wrap" {...rest}>
			<VStack alignItems="initial" spacing="spacing.xs">
				{claim.subLabels.map(({id, name, providerName, upc}) => (
					<VStack key={id} alignItems="initial" spacing={0}>
						<Text data-testid="artist-name-cell-title">
							<Text
								as="span"
								fontWeight="semibold"
								data-testid="label-claim-cell-title"
							>
								{name}
							</Text>
						</Text>
						<Text>
							<Text as="span" data-testid="label-claim-cell-provider-name">
								{providerName}
							</Text>
							<Text as="span" data-testid="label-claim-cell-upc">
								{` - ${upc}`}
							</Text>
						</Text>
					</VStack>
				))}
			</VStack>
		</Td>
	);
};

export default LabelClaimCell;
